import { baseApi } from 'services/baseApi';
import { AppConstants } from 'constants/index';
import { LocaleResources } from 'app/locale/types';

export const localeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLocaleResources: builder.query<LocaleResources, void>({
      query: () => {
        const { ReportingAdmin, Translation } = AppConstants.api;
        return {
          url: [ReportingAdmin, Translation],
        };
      },
    }),
  }),
});

export const { useLazyGetLocaleResourcesQuery } = localeApi;
